/* Display adapter for the official Forms block. Submission remains owned by Forms. */
(() => {
  if (customElements.get('ageta-contact-forms')) return;

  class AgetaContactForms extends HTMLElement {
    connectedCallback() {
      const applyStyles = () => {
        const host = this.querySelector('[data-forms-id="forms-root-1146525"] shopify-forms-embed');
        const shadow = host?.shadowRoot;
        if (!shadow) return;
        if (this.formShadow !== shadow) {
          this.shadowObserver?.disconnect();
          this.formShadow = shadow;
          this.shadowObserver = new MutationObserver(applyStyles);
          this.shadowObserver.observe(shadow, { childList: true, subtree: true });
        }
        // Link the existing plain disclaimer without replacing Forms-authored links.
        const disclaimer = Array.from(shadow.querySelectorAll('p')).find((paragraph) =>
          paragraph.childElementCount === 0 &&
          paragraph.textContent === 'プライバシーポリシーおよび利用規約をご覧ください。'
        );
        if (disclaimer) {
          const policyLink = (text, href) => {
            const anchor = document.createElement('a');
            anchor.textContent = text;
            anchor.href = href;
            anchor.target = '_blank';
            anchor.rel = 'noopener noreferrer';
            anchor.setAttribute('aria-label', `${text}（新しいタブで開く）`);
            anchor.style.textDecoration = 'underline';
            return anchor;
          };
          disclaimer.replaceChildren(
            policyLink('プライバシーポリシー', '/policies/privacy-policy'),
            'および',
            policyLink('利用規約', '/policies/terms-of-service'),
            'をご覧ください。'
          );
        }
        // Forms supplies a label's `for`, but currently omits the textarea id.
        // Keep the label usable after moving it above the control.
        const message = shadow.querySelector('textarea[name="custom#customageta_inquiry_body"]');
        const label = shadow.querySelector('label[for="custom#customageta_inquiry_body"]');
        if (message && label && !message.id) message.id = label.htmlFor;
        if (shadow.querySelector('[data-ageta-contact-styles]')) return;
        const stylesheet = this.dataset.stylesheet;
        if (!stylesheet) return;
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = stylesheet;
        link.dataset.agetaContactStyles = '';
        shadow.append(link);
      };
      this.observer = new MutationObserver(applyStyles);
      this.observer.observe(this, { childList: true, subtree: true });
      customElements.whenDefined('shopify-forms-embed').then(() => {
        if (this.isConnected) applyStyles();
      });
      applyStyles();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.shadowObserver?.disconnect();
      this.formShadow = null;
    }
  }

  customElements.define('ageta-contact-forms', AgetaContactForms);
})();
